import PropTypes from "prop-types";

/** Teacher card for a catalog benchmark item. Batch description can hide the input. */
const FluencyWpmField = ({
    canEdit,
    inputLabel,
    label,
    maxLength,
    onChange,
    placeholder,
    showInput,
    stem,
    teacherGuidance,
    value
}) => (
    <div className="fluency-wpm-field" data-testid="fluency-wpm-field">
        <div className="fluency-wpm-field__label">{label}</div>
        {stem ? <p className="fluency-wpm-field__stem">{stem}</p> : null}
        {teacherGuidance ? (
            <div className="fluency-wpm-field__guidance-block">
                <div className="fluency-wpm-field__guidance-label">Teacher guidance</div>
                <p className="fluency-wpm-field__guidance">{teacherGuidance}</p>
            </div>
        ) : null}
        {showInput ? (
            <label className="fluency-wpm-field__input-label">
                {inputLabel}
                <input
                    aria-label={`${label} ${inputLabel}`}
                    className="fluency-wpm-field__input"
                    disabled={!canEdit}
                    inputMode="numeric"
                    maxLength={maxLength}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    type="text"
                    value={value || ""}
                />
            </label>
        ) : null}
    </div>
);

FluencyWpmField.propTypes = {
    canEdit: PropTypes.bool,
    inputLabel: PropTypes.string,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    showInput: PropTypes.bool,
    stem: PropTypes.string,
    teacherGuidance: PropTypes.string,
    value: PropTypes.string
};

FluencyWpmField.defaultProps = {
    canEdit: true,
    inputLabel: "Current WPM",
    label: "Reading Fluency",
    maxLength: 3,
    onChange: () => {},
    placeholder: "e.g. 59",
    showInput: true,
    stem: null,
    teacherGuidance: null,
    value: ""
};

export default FluencyWpmField;
